// Public editorial IDs only. Never admit arbitrary URLs, prompts or song IDs.
// Index eligibility reviewed 2026-10-29 against published content and sitemap.
// New Discover pages stay noindex until explicitly reviewed here.
export const discoverContent = {
  "ai-birthday-song-generator": true,
  "ai-love-song-generator": true,
  "ai-wedding-song-generator": true,
  "ai-anniversary-song-generator": true,
  "ai-funny-song-generator": true,
  "ai-diss-track-generator": true,
  "youtube-intro-music-generator": true,
  "podcast-intro-music-generator": true,
  "tiktok-song-generator": true,
  "game-background-music-generator": true,
  "royalty-free-ai-music-generator": false,
  "commercial-use-ai-music-generator": true,
  "ai-rap-song-generator": true,
  "ai-pop-song-generator": true,
  "ai-country-song-generator": true,
  "ai-rock-song-generator": true,
  "ai-anime-song-generator": true,
  "ai-lofi-music-generator": true,
  "ai-jazz-music-generator": true,
  "ai-edm-generator": true
};
export const guideContent = new Set([
  "ai-music-platform",
  "musicmint-vs-ai-chatbots",
  "royalty-free-ai-music-licensing",
  "ai-music-library",
  "lyrics-generator-workflow",
  "vocal-separation-tool",
  "music-content-tools-for-creators",
  "wedding-music-workflow",
  "birthday-anniversary-music-ideas",
  "youtube-podcast-background-music",
  "game-stream-background-music",
  "meditation-sleep-music",
  "karaoke-vocal-practice-workflow",
  "short-video-social-music",
  "brand-ad-commercial-music",
  "fitness-workout-music",
  "study-focus-lofi-music"
]);
export const toolContent = new Set(['rap-name-generator', 'rap-lyrics-generator', 'lyrics-generator']);
export function contentContext(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return {};
  const raw = value.split(/[?#]/)[0].replace(/\/$/, '') || '/';
  const locale = raw.match(/^\/(en|zh|zh-TW|ja|ko|fr|de|es)(?=\/|$)/)?.[1];
  const path = raw.replace(/^\/(?:en|zh|zh-TW|ja|ko|fr|de|es)(?=\/|$)/, '');
  const [, kind, slug] = path.split('/');
  if (kind === 'discover' && Object.hasOwn(discoverContent, slug) && path === `/discover/${slug}`)
    return { content_id: `discover/${slug}`, content_source: 'discover', content_locale: 'en' };
  if (kind === 'guides' && guideContent.has(slug) && path === `/guides/${slug}`)
    return { content_id: `guides/${slug}`, content_source: 'guide', content_locale: locale || 'en' };
  if (toolContent.has(kind) && path === `/${kind}`)
    return { content_id: kind, content_source: 'tool', content_locale: locale || 'en' };
  return {};
}
export function isDiscoverIndexable(slug) { return discoverContent[slug] === true; }
